<template>
    <FilterExpandCollapse label="Gender" :expand="expanded" v-if="filterContext.type === 'doctor' || filterContext.type === 'dentist'">
      <div>
        <div>
          <hp5-semantic size-selection="xs">
            <input type="radio" name="gender" id="all" value="" v-model="filterContext.gender" /><label for="all">All</label>
          </hp5-semantic>
        </div>
        <div>
          <hp5-semantic size-selection="xs">
            <input type="radio" name="gender" id="male" value="Male" v-model="filterContext.gender" /><label for="male">Male</label>
          </hp5-semantic>
        </div>
        <div>
          <hp5-semantic size-selection="xs">
            <input type="radio" name="gender" id="female" value="Female" v-model="filterContext.gender" /><label for="female">Female</label>
          </hp5-semantic>
        </div>
      </div>
    </FilterExpandCollapse>
</template>

<script setup>
    const { filterContext } = useFCPModel()
    const expanded = computed(() => (filterContext.value.gender ? true : false))
</script>
  
<style scoped>
  label {
    padding-left: 10px;
  }
</style>